import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { notifyWarning } from '../errors/errorHandling';

function AppToastProvider() {
  useEffect(() => {
    const handleOffline = () => notifyWarning(
      'You are offline',
      'Changes cannot be saved until your connection returns.',
      'app:offline'
    );
    const handleOnline = () => {
      toast.dismiss('app:offline');
      toast.success('Connection restored', { toastId: 'app:online', autoClose: 3000 });
    };
    // Logged only: a failed request is already toasted by the fetch observer, and
    // most other stray rejections (an .unwrap() nobody caught after its own
    // message was shown) are not something the user can act on — a generic
    // "Something did not work" toast there only alarms them for nothing.
    const handleUnhandledRejection = (event) => {
      if (event.reason?.name !== 'AbortError') {
        console.error('Unhandled promise rejection', event.reason);
      }
    };
    // Logged only, for the same reason: render crashes already show the error
    // screen (React re-fires them here in development), and errors from browser
    // extensions or third-party scripts are nothing the user can act on.
    const handleWindowError = (event) => {
      if (event.error) console.error('Uncaught error', event.error);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleWindowError);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleWindowError);
    };
  }, []);

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={4}
      role="alert"
      theme="light"
      className="rize-toast-container"
      toastClassName="rize-toast"
    />
  );
}

export default AppToastProvider;
